import React from "react";
import { useQuery } from "@tanstack/react-query";
import { readFieldsByCollection } from "@directus/sdk";
import client from "directus/src/client";
import { FormDescription, useFormField } from "ui/components/form";

function useFieldNotes(collection) {
  const { data } = useQuery({
    queryKey: ["directus-field-notes", collection],
    queryFn: async () => {
      const fields = await client.request(readFieldsByCollection(collection));
      return Object.fromEntries(
        fields.filter((f) => f.meta?.note).map((f) => [f.field, f.meta.note])
      );
    },
    enabled: !!collection,
    staleTime: Infinity,
  });
  return data ?? {};
}

/**
 * Renders the field's "Note" from Directus as the form description.
 * Place inside a <FormItem>; the field name comes from the surrounding <FormField>.
 */
export function FormFieldDescription({ collection, className }) {
  const { name } = useFormField();
  const notes = useFieldNotes(collection);
  const note = notes[name];
  if (!note) return null;
  return <FormDescription className={className}>{note}</FormDescription>;
}
